import { Getter } from "vuex";
import { IState } from "./state";

const hits: Getter<IState, IState> = (state) => state.searchResult.searchHits;
const showMore: Getter<IState, IState> = (state) => {
  return (
    state.searchResult.totalHits > (state.currentPage + 1) * state.hitsPerPage
  );
};
const totalHits: Getter<IState, IState> = (state) =>
  state.searchResult.totalHits;
const showingHits: Getter<IState, IState> = (state) =>
  state.searchResult.searchHits.length;
const query: Getter<IState, IState> = (state) => state.query;
const shouldFocus: Getter<IState, IState> = (state) => state.focus.shouldFocus;
const focusIndex: Getter<IState, IState> = (state) => state.focus.index;
const hitsPerPage: Getter<IState, IState> = (state) => state.hitsPerPage;
const searchedQuery: Getter<IState, IState> = (state) => state.searchedQuery;
const suggestion: Getter<IState, IState> = (state) => state.suggestion;
const translations: Getter<IState, IState> = (state) => state.translations;

export default {
  hits,
  showMore,
  totalHits,
  showingHits,
  query,
  shouldFocus,
  hitsPerPage,
  focusIndex,
  searchedQuery,
  suggestion,
  translations,
};
